import { Binary, Gauge, ScanSearch } from 'lucide-react';
import BigShift from "../assets/big_shift.avif"
import "./AISection.css"

const capabilities = [
  { icon: ScanSearch, title: 'Pattern recognition', text: 'Finds correlations across vast volumes of information.' },
  { icon: Gauge, title: 'Processing speed', text: 'Executes repeatable operations with extraordinary efficiency.' },
  { icon: Binary, title: 'Predictive automation', text: 'Models likely outcomes and scales routine decisions.' },
];

export default function AISection() {
  return (
    <section className="intelligence-section intelligence-section--ai section" id="ai">
      <div className="container intelligence-grid">
        <div className="intelligence-visual reveal">
          <div className="image-panel image-panel--ai">
            <img src={BigShift} alt="Illustration describing the epistemological crisis of the machine age" />
          </div>
          <div className="image-caption">
            <span>Machine capacity</span>
            <strong>Computation · prediction · pattern · speed</strong>
          </div>
        </div>

        <div className="intelligence-copy reveal reveal--delay">
          <span className="eyebrow"><i /> Artificial Intelligence</span>
          <h2>An extraordinary instrument  but an incomplete origin.</h2>
          <p className="lead">
            Artificial intelligence is excellent at computation, prediction and automation. Its strength is operational.
            It processes the world, but it does not independently author human meaning, moral judgment or belonging.
          </p>
          <blockquote>
            “Technology is magnificent as an instrument, but disastrous as a master.”
          </blockquote>
        </div>
      </div>
      <div className="capability-list container">
        {capabilities.map(({ icon: Icon, title, text }) => (
          <article key={title}>
            <span><Icon size={20} strokeWidth={1.7} /></span>
            <div><h3>{title}</h3><p>{text}</p></div>
          </article>
        ))}
      </div>
    </section>
  );
}
